export default {
  id: null,
  permissionType: null,
  groupID: null,
  accountID: null,
  permissionUsed: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/permissionmodel.js